import './TrustpilotRatingWidget.scss';

import { Icon, useConfig } from '@travelwin/core';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { useLocaleUtils } from '../../../hooks/useLocaleUtils';
import { Align } from '../RatingWidget';
import { forceWidgetReload, loadTrustpilotScript } from './TrustpilotScript';

const className = 'c-TrustpilotRatingWidget';

const TRUSTPILOT_ICON = 'trustpilot';

export const TrustpilotRatingWidget = ({ align }: { align: Align }) => {
  const {
    TRUSTPILOT_WIDGET_BUSINESS_UNIT_ID,
    TRUSTPILOT_WIDGET_TEMPLATE_ID,
    TRUSTPILOT_WIDGET_DATA_TOKEN,
    TRUSTPILOT_WIDGET_LINK,
  } = useConfig();

  const { t } = useTranslation();
  const { currentLocale } = useLocaleUtils();

  const ref = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    const firstTimeLoading = loadTrustpilotScript();

    if (!firstTimeLoading && ref.current) {
      forceWidgetReload(ref.current);
    }
  }, [location.key]);

  return (
    <div className={classNames(className, `${className}--${align}`)}>
      <div className={`${className}__icon_and_text`}>
        <Icon className={`${className}__icon`} name={TRUSTPILOT_ICON} />
        <span className={`${className}__text`}>
          {t('trustpilot.rating', 'Excellent')}
        </span>
      </div>
      <div
        ref={ref}
        className={classNames('trustpilot-widget', `${className}__widget`)}
        data-style-height="100%"
        data-style-width="100%"
        data-locale={currentLocale}
        data-template-id={TRUSTPILOT_WIDGET_TEMPLATE_ID}
        data-businessunit-id={TRUSTPILOT_WIDGET_BUSINESS_UNIT_ID}
        data-token={TRUSTPILOT_WIDGET_DATA_TOKEN}
        data-stars="4,5"
        data-font-family="Roboto"
        data-review-languages={currentLocale}
      >
        <a
          className={`${className}__widget__link`}
          href={TRUSTPILOT_WIDGET_LINK}
          target="_blank"
          rel="noreferrer noopener"
        >
          {'Trustpilot'}
        </a>
      </div>
    </div>
  );
};

export default TrustpilotRatingWidget;
